import { useIsDesktopDevice } from '../../tools/hooks/useIsDesktopDevice.ts';
import ReportingDesktopView from './desktop/Reporting.desktop.view.tsx';

export default function ReportingView() {
  const isDesktop = useIsDesktopDevice();

  return <>{isDesktop && <ReportingDesktopView />}</>;
}
